import { Brand } from '../components/Brand';

/**
 * ONB-004 (FI-70): una instalación sin ningún dueño activo. Ya no existe un arranque anónimo por la web
 * (antes, «Crear usuario maestro» creaba el primer dueño sin verificar nada). El primer negocio y su dueño
 * se crean desde Plataforma (#platform), con la cuenta de administrador que da de alta el CLI
 * `packages/backend/prisma/createPlatformAdmin.ts`.
 */
export function SetupPendingPage() {
  return (
    <main className="auth-shell">
      <section className="auth-visual" aria-label="Negocio360">
        <Brand />
        <div className="auth-visual__content">
          <span className="eyebrow eyebrow--light">Control de negocio</span>
          <h1>Tu operación, clara y en un solo lugar.</h1>
        </div>
        <div className="auth-visual__footer">Acceso seguro para tu negocio</div>
      </section>

      <section className="auth-form-panel">
        <div className="auth-form-card">
          <span className="eyebrow">Instalación nueva</span>
          <h2>Esta instalación todavía no tiene un negocio</h2>
          <p className="form-intro">
            El primer negocio y su dueño se crean desde el panel de Plataforma, con una cuenta de administrador.
          </p>
          <p className="auth-help">
            <a className="text-button" href="#platform">Ir a Plataforma</a>
          </p>
        </div>
      </section>
    </main>
  );
}
